import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { resortById } from '../data/resorts'
import { PassChip } from '../components/PassChip'
import { buildSeasonPayload, encodePayload } from '../lib/share'
import { formatMoney } from '../lib/roi'
import { useStore } from '../lib/state'
import { passById } from '../data/passes'

export function Season() {
  const { state, metrics } = useStore()
  const [copied, setCopied] = useState(false)

  const payload = useMemo(
    () =>
      buildSeasonPayload({
        name: state.profile.displayName || 'Skier',
        passId: state.profile.passId,
        seasonLabel: state.profile.seasonLabel,
        stamps: state.stamps,
        days: state.days,
        priceUsd: metrics.passPrice,
      }),
    [state, metrics.passPrice],
  )

  const sharePath = `/s/${encodePayload(payload)}`
  const shareUrl = typeof window !== 'undefined' ? `${window.location.origin}${sharePath}` : sharePath

  const visited = state.stamps.filter((s) => s.status === 'visited')
  const want = state.stamps.filter((s) => s.status === 'want')

  return (
    <div className="stack">
      <div className="card stack">
        <div className="page-head">
          <h2>Shareable season card</h2>
          <p className="muted">
            A public, image-friendly page of your passport. Data is encoded in the link — no account required
            to view.
          </p>
        </div>
        <div className="row">
          <button
            className="btn primary"
            onClick={() => {
              navigator.clipboard?.writeText(shareUrl)
              setCopied(true)
              setTimeout(() => setCopied(false), 2000)
            }}
          >
            {copied ? 'Copied' : 'Copy share link'}
          </button>
          <Link className="btn" to={sharePath} target="_blank">
            Open public card
          </Link>
        </div>
      </div>

      <div className="season-card-preview">
        <div className="kicker">Passfolio · {state.profile.seasonLabel}</div>
        <h1>{state.profile.displayName || 'Your name'}</h1>
        <div className="row">
          <PassChip id={state.profile.passId} />
          <span className="muted" style={{ fontSize: 13 }}>
            {passById(state.profile.passId).label}
          </span>
        </div>
        <div className="metric-grid" style={{ marginTop: 18 }}>
          <div className="metric">
            <div className="label">Visited</div>
            <div className="value" style={{ color: 'var(--good)' }}>{metrics.visited}</div>
          </div>
          <div className="metric">
            <div className="label">Wishlist</div>
            <div className="value" style={{ color: 'var(--want)' }}>{metrics.want}</div>
          </div>
          <div className="metric">
            <div className="label">Days</div>
            <div className="value">{metrics.days}</div>
          </div>
          <div className="metric">
            <div className="label">$/day</div>
            <div className="value" style={{ color: 'var(--accent)' }}>
              {metrics.cpd ? formatMoney(metrics.cpd) : '—'}
            </div>
          </div>
        </div>
        <div style={{ marginTop: 18 }} className="stack">
          <div>
            <div className="kicker">Stamped</div>
            <div className="row" style={{ marginTop: 8 }}>
              {visited.length === 0 && <span className="muted">No stamps yet</span>}
              {visited.slice(0, 12).map((s) => (
                <span className="chip" key={s.resortId} style={{ borderColor: 'rgba(94,255,194,0.3)' }}>
                  {resortById(s.resortId)?.name ?? s.resortId}
                </span>
              ))}
              {visited.length > 12 && <span className="faint">+{visited.length - 12} more</span>}
            </div>
          </div>
          <div>
            <div className="kicker">Want to go</div>
            <div className="row" style={{ marginTop: 8 }}>
              {want.length === 0 && <span className="muted">Empty wishlist</span>}
              {want.slice(0, 12).map((s) => (
                <span className="chip" key={s.resortId} style={{ borderColor: 'rgba(255,213,106,0.35)' }}>
                  {resortById(s.resortId)?.name ?? s.resortId}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
